import React, { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import NewsSourceManagement from '../../components/admin/insight/NewsSourceManagement';
import NewsArticleManagement from '../../components/admin/insight/NewsArticleManagement';
import AnalysisTemplateManagement from '../../components/admin/insight/AnalysisTemplateManagement';
import OfficialAnalysisManagement from '../../components/admin/insight/OfficialAnalysisManagement';

const InsightManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('official-analysis');

  const tabs = [
    { id: 'official-analysis', name: '官方深度分析', component: <OfficialAnalysisManagement /> },
    { id: 'news-articles', name: '新闻内容管理', component: <NewsArticleManagement /> },
    { id: 'analysis-templates', name: '分析模板管理', component: <AnalysisTemplateManagement /> },
    { id: 'news-sources', name: '新闻源管理', component: <NewsSourceManagement /> }
  ];

  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">新闻洞察管理</h1>
          <p className="text-gray-600">管理新闻源、新闻内容、分析模板和官方深度分析</p>
        </div>

        {/* 标签页导航 */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* 标签页内容 */}
        <div className="mt-6">
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </AdminLayout>
  );
};

export default InsightManagement;